import React from 'react'
import style from './styles.module.css'
import Topheader from '../../components/Topheader'
export default function CoinDetailsNew() {
  return (
     <>
         <div>
            <Topheader colorbox="newfaq_header_color" title="Detalye ng Coins"/>
           <div className="top-container container">
             <img
               src={require("../../images/coins-detail/mainbanner.webp")}
               alt="main banner"
               className="img-fluid py-4"
             />
           </div>
           <div className="container">
             <div className="">
               <div className={style.sec2_text1}>
                 Ano ang mga Coins?
               </div>
               <div className={style.sec2_text2}>
                Ang Coins ay isang pera na natatanggap ng isang manlalaro kapag sila ay nakiisa sa isang sikat na laro kung saan may kinukuhang komisyon ang operator para sa pagpapadali ng mga serbisyo ng laro. Ang convenience fee na sinisingil sa komisyon o rake ay hindi kasama sa pagkalkula ng coins.
               </div>
             </div>
           </div>
            <div className={style.sec3}>
    <div className={style.sec2_text1}>
        Paano nabubuo ang mga Coins?
    </div>
    <div className={style.sec3_box}>
         <img
               src={require("../../images/coins-detail/step-2.png")}
               alt="main banner"
               className="img-fluid py-3"
               width={56}
             />
             <div className="">
                <div className={style.sec3_box_text1}>Hakbang 1: Maglaro ng Sikat na Laro</div>
                 <div className={style.sec3_box_text2}>I-tap ang icon sa HomeScreen upang makita ang lahat ng available na reward.</div>
             </div>
    </div>
     <div className={style.sec3_box}>
         <img
               src={require("../../images/coins-detail/step-1.png")}
               alt="main banner"
               className="img-fluid py-3"
               width={56}

             />
             <div className="">
                <div className={style.sec3_box_text1}>Hakbang 2: Kumita ng Coins</div>
                 <div className={style.sec3_box_text2}>Kumita ng coins na katumbas ng rake na iyong nagawa habang nilalaro ang kamay.</div>
             </div>
    </div>
   </div>
         </div>
       </>
  )
}
